module.exports = __webpack_public_path__ + "img/yerc.2f12d64d.png";